import { useMemo } from "react";

// v0.5.0g+2 — "hide duplicate filenames" pass, moved out of CalculatePanel
// (500-line cap, A2-467). When `hideDupes` is on, group by filename and keep
// only the most recent ingest of each; `earlierCountByRow` maps the visible
// row id to the number of hidden siblings, so RunRow can show "+N earlier".
export const useDuplicateCollapse = (searchedProdRuns, hideDupes) => useMemo(() => {
  if (!hideDupes) {
    return { displayedProdRuns: searchedProdRuns, earlierCountByRow: {}, duplicateCount: 0 };
  }
  const groups = new Map();
  for (const r of searchedProdRuns) {
    const key = r.filename || r.id;
    const arr = groups.get(key) || [];
    arr.push(r);
    groups.set(key, arr);
  }
  const out = [];
  const earlier = {};
  let hidden = 0;
  for (const arr of groups.values()) {
    // searchedProdRuns is sorted newest first, so arr[0] is the newest.
    out.push(arr[0]);
    if (arr.length > 1) {
      earlier[arr[0].id] = arr.length - 1;
      hidden += arr.length - 1;
    }
  }
  out.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
  return { displayedProdRuns: out, earlierCountByRow: earlier, duplicateCount: hidden };
}, [searchedProdRuns, hideDupes]);
